import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const AuthGuard = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    checkAuthentication();
  }, [location.pathname]);

  const checkAuthentication = async () => {
    try {
      // Try to get auth from cookie first, then localStorage
      const token = localStorage.getItem('token') || localStorage.getItem('passwordless_token');
      
      if (token) {
        // Verify token is still valid
        const response = await axios.get('/api/auth/me', {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        if (response.data.user) {
          setIsAuthenticated(true);
          setIsLoading(false);
          return;
        }
      }

      // No valid authentication found
      setIsAuthenticated(false);
      setIsLoading(false);
      
      // Redirect to passwordless login with the current path as redirect
      const redirectTo = encodeURIComponent(location.pathname + location.search);
      navigate(`/passwordless-login?redirectTo=${redirectTo}`);
      
    } catch (error) {
      console.error('Auth check failed:', error);
      setIsAuthenticated(false);
      setIsLoading(false);
      
      // Redirect to login with current path
      const redirectTo = encodeURIComponent(location.pathname + location.search);
      navigate(`/passwordless-login?redirectTo=${redirectTo}`);
    }
  };

  if (isLoading) {
    return null; // Silent loading
  }

  if (!isAuthenticated) {
    return null; // Will redirect in useEffect
  }

  return children;
};

export default AuthGuard; 